import { NavLink, Link } from 'react-router-dom';
import Logo from '../ui/Logo';
import LogoutButton from '../auth/LogoutButton';
import './layout.css';

/**
 * Sidebar — desktop navigation (hidden on mobile via CSS).
 *
 * Props:
 *   sections           - array of { id, label, icon, path, visible } objects
 *   onRestartTutorial  - optional callback to re-run the onboarding tour
 *   onEditProfile      - optional callback to open the user profile setup modal
 */
export default function Sidebar({ sections = [], onRestartTutorial, onOpenFeedback }) {
  const visibleSections = sections.filter((s) => s.visible !== false);

  return (
    <nav
      className="app-sidebar"
      aria-label="Main navigation"
      data-testid="sidebar"
    >
      <NavLink to="/app" className="sidebar-brand" aria-label="Baby Tracker home">
        <Logo variant="full" size={28} />
      </NavLink>

      <ul className="sidebar-nav" data-tutorial="sidebar-nav">
        {visibleSections.map((section) => (
          <li key={section.id}>
            <NavLink
              to={section.path}
              end={section.path === '/app'}
              className={({ isActive }) =>
                `sidebar-nav-item${isActive ? ' active' : ''}`
              }
              {...(section.id === 'bottleFeeds' ? { 'data-tutorial': 'nav-bottle-feeds' } : {})}
            >
              {section.icon && (
                <span className="sidebar-nav-icon" aria-hidden="true">
                  {section.icon}
                </span>
              )}
              {section.label}
            </NavLink>
          </li>
        ))}
      </ul>

      <div className="sidebar-footer">
        <Link
          to="/app/settings"
          className="tutorial-restart-btn"
          data-tutorial="settings-link"
          title="App settings"
          style={{ textDecoration: 'none' }}
        >
          <span aria-hidden="true">⚙️</span> Settings
        </Link>
        {onRestartTutorial && (
          <button className="tutorial-restart-btn" onClick={onRestartTutorial} title="Restart onboarding tour">
            <span aria-hidden="true">🎓</span> Restart tour
          </button>
        )}
        {onOpenFeedback && (
          <button className="tutorial-restart-btn" onClick={onOpenFeedback} title="Send feedback or report a problem">
            <span aria-hidden="true">💬</span> Send feedback
          </button>
        )}
        <LogoutButton />
      </div>
    </nav>
  );
}
